import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltConfirmDialogTitleWireframe from './VeltConfirmDialogTitleWireframe/VeltConfirmDialogTitleWireframe';
import VeltConfirmDialogMessageWireframe from './VeltConfirmDialogMessageWireframe/VeltConfirmDialogMessageWireframe';
import VeltConfirmDialogApproveButtonWireframe from './VeltConfirmDialogApproveButtonWireframe/VeltConfirmDialogApproveButtonWireframe';
import VeltConfirmDialogRejectButtonWireframe from './VeltConfirmDialogRejectButtonWireframe/VeltConfirmDialogRejectButtonWireframe';
var VeltConfirmDialogWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-confirm-dialog-wireframe", __assign({}, transformedProps), children));
};
VeltConfirmDialogWireframe.Title = VeltConfirmDialogTitleWireframe;
VeltConfirmDialogWireframe.Message = VeltConfirmDialogMessageWireframe;
VeltConfirmDialogWireframe.ApproveButton = VeltConfirmDialogApproveButtonWireframe;
VeltConfirmDialogWireframe.RejectButton = VeltConfirmDialogRejectButtonWireframe;
export default VeltConfirmDialogWireframe;
